import {Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import { AuthGaurd } from './auth.service';
import { AdminsComponent } from 'app/users/admins/admins.component';
import { DriversComponent } from 'app/users/drivers/drivers.component';
import { VehiclesComponent } from 'app/fleet-management/vehicles/vehicles.component';
import { CustomersComponent } from './users/customers/customers.component';
import { ManageAdminComponent } from './users/admins/manage-admin/manage-admin.component';
import { ManageDriverComponent } from './users/drivers/manage-driver/manage-driver.component';
import { ManageBranchComponent } from './branches/manage-branch/manage-branch.component';
import { BranchesComponent } from './branches/branches.component';
import { ManageShipmentComponent } from './logistics-operations/manage-shipment/manage-shipment.component';
import { AddShipmentComponent } from './logistics-operations/add-shipment/add-shipment.component';
import { ViewShipmentDetailsComponent } from './logistics-operations/view-shipment-details/view-shipment-details.component';
import { BarcodeComponent } from './logistics-operations/barcode/barcode.component';
import { FinanceComponent } from './logistics-operations/finance/finance.component';
import { ManageCustomerComponent } from './users/customers/manage-customer/manage-customer.component';
import { ContactsComponent } from './users/contacts/contacts.component';
import { CitiesComponent } from './logistics-operations/cities/cities.component';
import { DashboardMainComponent } from './logistics-operations/dashboard-main/dashboard-main.component';
import { ExpensesComponent } from './fleet-management/expenses/expenses.component';
import { SettingsComponent } from './settings/settings.component';
import { HrmsComponent } from './hrms/hrms.component';
import { EmployeeComponent } from './hrms/employee/employee.component';
import { LeavesComponent } from './hrms/leaves/leaves.component';
import { SupervisorsComponent } from './users/supervisors/supervisors.component';
import { AttendanceComponent } from './hrms/attendance/attendance.component';
import { UserProfilePageComponent } from './layouts/user-profile-page/user-profile-page.component';
import { CompanyComponent } from './hrms/company/company.component';
import { HolidaysComponent } from './hrms/holidays/holidays.component';
import { PayrollComponent } from './hrms/payroll/payroll.component';
import { VisaExpiryComponent } from './hrms/overview/visa-expiry/visa-expiry.component';
import { VehicleAddComponent } from './fleet-management/vehicle-add/vehicle-add.component';
import { VehicleInspectionComponent } from './fleet-management/vehicle-inspection/vehicle-inspection.component';
import { FleetDashboardComponent } from './fleet-management/fleet-dashboard/fleet-dashboard.component';
import { FleetSettingsComponent } from './fleet-management/fleet-settings/fleet-settings.component';
import { ViewEmployeeDetailsComponent } from './hrms/employee/view-employee-details/view-employee-details.component';
import { UsersComponent } from './users/users.component';
import { FinanceDashboardComponent } from './finance-management/finance-dashboard/finance-dashboard.component';
import { FinanceSettingsComponent } from './finance-management/finance-settings/finance-settings.component';
import { FinanceTransactionsComponent } from './finance-management/finance-transactions/finance-transactions.component';
import { SalaryComponent } from './hrms/payroll/salary/salary.component';
import { ProfitLossComponent } from './finance-management/profit-loss/profit-loss.component';
import { TestcomponentComponent } from './testcomponent/testcomponent.component';
import { FinanceAccountComponent } from './finance-management/finance-account/finance-account.component';


export const AppRoutes: Routes = [{
  path: '',
  component: AdminLayoutComponent,
  children: [
    {
      path: 'dashboard',
      component: DashboardMainComponent,
      data: {
        breadcrumb: 'Dashboard',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'admins',
      component: AdminsComponent,
      data: {
        breadcrumb: 'Admins',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'drivers',
      component: DriversComponent,
      data: {
        breadcrumb: 'Drivers',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'supervisors',
      component: SupervisorsComponent,
      data: {
        breadcrumb: 'Supervisors',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'branches',
      component: BranchesComponent,
      data: {
        breadcrumb: 'Add Branches',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-admin',
      component: ManageAdminComponent,
      data: {
        breadcrumb: 'Manage Admin',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd],
    },
    {
      path: 'manage-driver',
      component: ManageDriverComponent,
      data: {
        breadcrumb: 'Manage Driver',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-supervisor',
      component: ManageDriverComponent,
      data: {
        breadcrumb: 'Manage Supervisor',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-branch',
      component: ManageBranchComponent,
      data: {
        breadcrumb: 'Manage Branch',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-shipment',
      component: ManageShipmentComponent,
      data: {
        breadcrumb: 'Manage Shipment',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'add-shipment',
      component: AddShipmentComponent,
      data: {
        breadcrumb: 'Add Shipment',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'view-shipment-details',
      component: ViewShipmentDetailsComponent,
      data: {
        breadcrumb: 'Shipment Details',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'customers',
      component: CustomersComponent,
      data: {
        breadcrumb: 'Customers',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-customer',
      component: ManageCustomerComponent,
      data: {
        breadcrumb: 'Customers',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'manage-contacts',
      component: ManageCustomerComponent,
      data: {
        breadcrumb: 'Contacts',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'barcodes',
      component: BarcodeComponent,
      data: {
        breadcrumb: 'Barcodes',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'finance',
      component: FinanceComponent,
      data: {
        breadcrumb: 'Shipment Sales',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'contacts',
      component: ContactsComponent,
      data: {
        breadcrumb: 'Contact',
        icon: 'icofont-home bg-c-blue',
        status: false,
        onlySuperAdmin: true,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'cities',
      component: CitiesComponent,
      data: {
        breadcrumb: 'Cities',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'vehicles',
      component: VehiclesComponent,
      data: {
        breadcrumb: 'Vehicles',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'users',
      component: UsersComponent,
      data: {
        breadcrumb: 'Users',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'expenses',
      component: ExpensesComponent,
      data: {
        breadcrumb: 'Expenses',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'fleet-dashboard',
      component: FleetDashboardComponent,
      data: {
        breadcrumb: 'Fleet Dashboard',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'fleet-dashboard',
      component: FleetDashboardComponent,
      data: {
        breadcrumb: 'Fleet Dashboard',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'settings',
      component: SettingsComponent,
      data: {
        breadcrumb: 'Settings',
        icon: 'icofont-home bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'hrms',
      component: HrmsComponent,
      data: {
        breadcrumb: 'HRMS',
        icon: 'icofont-home bg-c-blue',
        status: false,
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'employees',
      component: EmployeeComponent,
      data: {
        breadcrumb: 'Employee',
        icon: 'icofont-home bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'leaves',
      component: LeavesComponent,
      data: {
        breadcrumb: 'Leaves',
        icon: 'icofont-home bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'attendance',
      component: AttendanceComponent,
      data: {
        breadcrumb: 'Attendance',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'profile',
      component: UserProfilePageComponent,
      data: {
        breadcrumb: 'Profile',
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'company',
      component: CompanyComponent,
      data: {
        breadcrumb: 'Company',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'holidays',
      component: HolidaysComponent,
      data: {
        breadcrumb: 'Holidays',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'payroll',
      component: PayrollComponent,
      data: {
        breadcrumb: 'Payroll',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'vehicle-add',
      component: VehicleAddComponent,
      data: {
        breadcrumb: 'Add Vehicle',
        icon: 'ti-view-grid bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'vehicle-inspection',
      component: VehicleInspectionComponent,
      data: {
        breadcrumb: 'Vehicle Inspection',
        icon: 'ti-view-grid bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'fleet-settings',
      component: FleetSettingsComponent,
      data: {
        breadcrumb: 'Fleet Management Settings',
        icon: 'ti-view-grid bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'visa-expiry',
      component: VisaExpiryComponent,
      data: {
        breadcrumb: 'Visa Expiry',
        icon: 'ti-view-grid bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'view-details',
      component: ViewEmployeeDetailsComponent,
      data: {
        breadcrumb: 'View Details',
        icon: 'ti-view-grid bg-c-blue',
        status: false,
        isDriverNotAllowed: true
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'finance-dashboard',
      component: FinanceDashboardComponent,
      data: {
        breadcrumb: 'Finance Dashboard',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'finance-transactions',
      component: FinanceTransactionsComponent,
      data: {
        breadcrumb: 'Transactions',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'finance-settings',
      component: FinanceSettingsComponent,
      data: {
        breadcrumb: 'Finance Settings',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'salary',
      component: SalaryComponent,
      data: {
        breadcrumb: 'Salary Component',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'profit-loss',
      component: ProfitLossComponent,
      data: {
        breadcrumb: 'Proft and Loss',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'test',
      component: TestcomponentComponent,
      data: {
        breadcrumb: 'test',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    },
    {
      path: 'finance-account',
      component: FinanceAccountComponent,
      data: {
        breadcrumb: 'Finance Account',
        icon: 'ti-view-grid bg-c-blue',
        status: false
      },
      canActivate: [AuthGaurd]
    }
        
  ]
}, {
  path: '',
  children: [{
    path: 'authentication',
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  }, {
    path: 'error',
    loadChildren: './error/error.module#ErrorModule'
  }]
}, {
  path: '**',
  redirectTo: 'error/404'
}];



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/app.routing.ts